import { Paths, PathValue } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater,
  IGKRapport,
} from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import { beregnetDiffMellomToVerdier } from "../gkGlobalUtils";
const MaalingAvDriftstrykk: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater;
}> = ({ data, onUpdateEditData }) => {
  useEffect(() => {
    utdataBeregninger();
  }, [
    data.inndata.avlestTrykkHovedkammer,
    data.inndata.maaltTrykkHovedkammer,
    data.inndata.maaltInterntrykkHoeyreSluse,
    data.inndata.avlestInterntrykkHoeyreSluse,
    data.inndata.maaltInterntrykkVenstreSluse,
    data.inndata.avlestInterntrykkVenstreSluse,
    data.inndata.maaltInterntrykkHovedfilter,
    data.inndata.avlestInterntrykkHovedfilter,
  ]);
  const utdataBeregninger = () => {
    const trykkDiffHovedkammer = beregnetDiffMellomToVerdier(
      data.inndata.maaltTrykkHovedkammer,
      data.inndata.avlestTrykkHovedkammer,
    );
    const trykkDiffHoeyreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkHoeyreSluse,
      data.inndata.avlestInterntrykkHoeyreSluse,
    );
    const trykkDiffVenstreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkVenstreSluse,
      data.inndata.avlestInterntrykkVenstreSluse,
    );
    const trykkDiffHovedfilter = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkHovedfilter,
      data.inndata.avlestInterntrykkHovedfilter,
    );
    const utdata = {
      trykkDiffHovedkammer: trykkDiffHovedkammer,
      trykkDiffHoeyreSluse: trykkDiffHoeyreSluse,
      trykkDiffVenstreSluse: trykkDiffVenstreSluse,
      trykkDiffHovedfilter: trykkDiffHovedfilter,
    };
    onUpdateEditData("testResultater.maalingAvDriftstrykk.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av interntrykk</Title>
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Hovedkammer:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestTrykkHovedkammer,
                  data.inndata.maaltTrykkHovedkammer,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Høyre sluse:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkHoeyreSluse,
                  data.inndata.maaltInterntrykkHoeyreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Venstre sluse:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkVenstreSluse,
                  data.inndata.maaltInterntrykkVenstreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Hovedfilter:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkHovedfilter}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkHovedfilter",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkHovedfilter}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkHovedfilter",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkHovedfilter,
                  data.inndata.maaltInterntrykkHovedfilter,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <h5 className="mb-0">I henhold til fabrikantens spesifikasjoner?</h5>
          <div className="d-flex flex-column">
                        <Radio
              checked={data.inndata.ihenholdTilFabrikant === true}
              onChange={() =>
              onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.ihenholdTilFabrikant", true)
              }
              label="Godkjent"
            />
                        <Radio
              checked={data.inndata.ihenholdTilFabrikant === false}
              onChange={() =>
              onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.ihenholdTilFabrikant", false)
              }
              label="Ikke godkjent"
            />
          </div>
        </div>
        <div className="w-50 mt-4">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.kommentar", e.target.value)}
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default MaalingAvDriftstrykk;